import { Outlet } from "react-router-dom";
import Sidebar from "./Sidebar";
import { useCallback, useEffect, useState } from "react";
import { List, Bell } from "@phosphor-icons/react";
import axios from "axios";
import ThemeToggle from "./ThemeToggle";
import NotificationCenter from "./NotificationCenter";
import { triggerHighPriorityPush } from "@/lib/push";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const [unreadCount, setUnreadCount] = useState(0);

  const refreshUnread = useCallback(async () => {
    try {
      const { data } = await axios.get(`${API}/notifications/unread-count`);
      setUnreadCount(data?.unread_count || 0);
      // Piggy-back: try flushing any pending high-priority web-push
      triggerHighPriorityPush();
    } catch (err) { console.debug("[AppLayout]", err); }
  }, []);

  useEffect(() => {
    refreshUnread();
    const t = setInterval(refreshUnread, 60000);
    return () => clearInterval(t);
  }, [refreshUnread]);

  const openNotif = () => setNotifOpen(true);

  return (
    <div className="flex h-screen bg-[#0A0A0A] overflow-hidden">
      {/* Mobile overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
          data-testid="sidebar-overlay"
        />
      )}

      <Sidebar
        open={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        unreadCount={unreadCount}
        onOpenNotifications={openNotif}
      />

      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        {/* Mobile header */}
        <div className="glass-header flex items-center h-14 px-4 lg:hidden">
          <button
            onClick={() => setSidebarOpen(true)}
            className="text-white p-1"
            data-testid="sidebar-toggle"
          >
            <List size={24} weight="bold" />
          </button>
          <span className="ml-3 text-lg font-bold tracking-tight" style={{ fontFamily: 'Barlow Condensed, sans-serif' }}>
            FITPRO
          </span>
          <div className="ml-auto flex items-center gap-2">
            <button
              onClick={openNotif}
              className="relative w-9 h-9 rounded-lg bg-[#171717] border border-[#262626] text-zinc-300 flex items-center justify-center"
              data-testid="notif-bell-mobile"
              aria-label="Notifiche"
            >
              <Bell size={16} weight="fill" />
              {unreadCount > 0 && (
                <span className="absolute -top-1 -right-1 min-w-[16px] h-[16px] px-1 rounded-full bg-[#FF3B30] border-2 border-[#0A0A0A] text-white text-[9px] font-bold flex items-center justify-center leading-none">
                  {unreadCount > 9 ? "9+" : unreadCount}
                </span>
              )}
            </button>
            <ThemeToggle size={16} />
          </div>
        </div>

        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <Outlet />
        </main>
      </div>

      <NotificationCenter
        open={notifOpen}
        onClose={() => { setNotifOpen(false); refreshUnread(); }}
        onUnreadChange={setUnreadCount}
      />
    </div>
  );
}
